import React from 'react';
import { Container, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

const NavigationHeaderBar = ({ handleDrawerToggle }) => {
  return (
    <Container style={{ width: '100%', zIndex: 1000, overflow: 'hidden', touchAction: 'none', position: 'sticky', top: 0, backgroundColor: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <IconButton
        color="inherit"
        aria-label="open drawer"
        edge="start"
        onClick={handleDrawerToggle}
        style={{ marginLeft: '0rem', marginTop: '1rem', marginBottom: '1rem' }}
        sx={{ mr: 2, display: { md: 'none' } }}>
        <MenuIcon />
      </IconButton>
    </Container>
  );
};

export default NavigationHeaderBar;
